import React from 'react';

import { Button } from 'react-bootstrap';

import { UpdateProfileImageModal } from 'components/modals/UpdateProfileImageModal/UpdateProfileImageModal';

import './styles.scss';

interface IEditProfilePictureWrapperProps {
    editPhoto?: boolean;
}

export const EditProfilePictureWrapper: React.FC<IEditProfilePictureWrapperProps> = ({
    editPhoto,
    children,
}) => {

    const [showEditPictureModal, setShowEditPictureModal] = React.useState<boolean>(false);

    if (editPhoto) {
        return (
            <div className="EditProfilePictureWrapper">
                {children}
                {showEditPictureModal && (
                    <UpdateProfileImageModal onClose={() => setShowEditPictureModal(false)} show={true}/>
                )}
                <div
                    className="EditProfilePictureWrapper__background"
                    onClick={() => setShowEditPictureModal(true)}
                >
                    <div className="EditProfilePictureWrapper__buttonBox">
                        <Button
                            className="EditProfilePictureWrapper__button"
                            variant="secondary"
                        >
                            Update
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
    return (
        <>
            {children}
        </>
    );
};